import {
  ADD_ALL_SCHUELER,
  // FETCH_SCHUELER,
  ADD_SCHUELER,
  UPDATE_SCHUELER,
  // DELETE_SCHUELER
} from "../actions/types";
import { sortArrayByObjectField } from "../helpers/sort";

function sortBySchuelerName(schueler) {
  // return schueler.sort(name => name);
  return sortArrayByObjectField(schueler, "nachname");
}

export default function rootReducer(state = [], action) {
  switch (action.type) {
    case ADD_SCHUELER:
      if (!action.schueler) return state;
      return sortBySchuelerName([...state, action.schueler]);
    case ADD_ALL_SCHUELER:
      if (!action.schueler) return state;
      return sortBySchuelerName([...state, ...action.schueler]);
    case UPDATE_SCHUELER:
      if (!action.schueler) return state;
      const { id } = action.schueler;
      return sortBySchuelerName([
        ...state.filter((s) => s.id !== id),
        action.schueler,
      ]);
   default:
      return state;
  }
}
